import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { PermissionService } from '../services/permission.service';
import { PermissionAction } from '../models/permission.model';

/**
 * Directiva de atributo que deshabilita (en vez de ocultar) un control cuando el usuario
 * no tiene el permiso. Útil para botones donde se prefiere mostrarlos atenuados.
 *
 * Uso:
 *   <button [appDisableWithoutPermission]="'contacts:edit'">Editar</button>
 */
@Directive({
  selector: '[appDisableWithoutPermission]',
  standalone: true,
})
export class DisableWithoutPermissionDirective implements OnInit, OnDestroy {
  private moduleCode = '';
  private action: PermissionAction = 'view';
  private sub?: Subscription;

  @Input('appDisableWithoutPermission') set value(v: string) {
    const [code, act] = (v ?? '').split(':');
    this.moduleCode = (code ?? '').trim();
    this.action = (act?.trim() as PermissionAction) || 'view';
    this.apply();
  }

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private permissions: PermissionService,
  ) {}

  ngOnInit(): void {
    this.sub = this.permissions.permissions$.subscribe(() => this.apply());
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private apply(): void {
    const allowed = !!this.moduleCode && this.permissions.has(this.moduleCode, this.action);
    if (allowed) {
      this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
      this.renderer.removeClass(this.el.nativeElement, 'opacity-50');
      this.renderer.removeClass(this.el.nativeElement, 'cursor-not-allowed');
    } else {
      this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
      this.renderer.addClass(this.el.nativeElement, 'opacity-50');
      this.renderer.addClass(this.el.nativeElement, 'cursor-not-allowed');
    }
  }
}
